import styled from '../styled';
import MaterialToggleButton from '@mui/material/ToggleButton';

export const StyledToggleButton = styled(MaterialToggleButton)(({ theme }) => ({
    '&.Mui-selected, &.Mui-selected:hover, &:hover': {
        color: theme.palette.primary.main,
        backgroundColor: `rgba(102, 181, 255, 0.08)`,
    },
}));
